/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseConversationMessageWindow } from '../../models/api-response-conversation-message-window';

export interface ListMessageWindow$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  convReference: string;
  limit?: number;
  before?: string;

/**
 * Messages older than this message (same conversation). Use at most one anchor.
 */
  beforeReference?: string;

/**
 * Messages newer than this message, oldest first.
 */
  afterReference?: string;

/**
 * A window centred on this message (e.g. jumping to a quoted message).
 */
  aroundReference?: string;
}

export function listMessageWindow(http: HttpClient, rootUrl: string, params: ListMessageWindow$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseConversationMessageWindow>> {
  const rb = new RequestBuilder(rootUrl, listMessageWindow.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('convReference', params.convReference, {});
    rb.query('limit', params.limit, {});
    rb.query('before', params.before, {});
    rb.query('beforeReference', params.beforeReference, {});
    rb.query('afterReference', params.afterReference, {});
    rb.query('aroundReference', params.aroundReference, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseConversationMessageWindow>;
    })
  );
}

listMessageWindow.PATH = '/v1/api/ui/message/{convReference}/window';
